import { FC } from 'react';

import { VirtualizedList } from '@/shared';
import EmptyWorkspaceResourceListView from '@/shared/components/layouts/views/EmptyWorkspaceResourceListView';
import { Team } from '@/types';

import TeamListItem from './TeamListItem';

interface TeamListProps {
    teams: Team[];
}

const TeamList: FC<TeamListProps> = ({ teams }): JSX.Element => {
    return teams?.length !== 0 ? (
        <VirtualizedList
            height='30rem'
            innerStyle={{ paddingInline: 0 }}
            items={teams}
            estimateSize={80}
            getItemKey={(team) => team.id}
            style={{ marginInline: '-0.375rem', width: 'calc(100% + 0.75rem)' }}
            paginate
            pageSize={50}
            renderItem={(team: Team) => <TeamListItem key={team?.id} team={team} />}
        />
    ) : (
        <EmptyWorkspaceResourceListView resourceType={'team'} height='30rem' />
    );
};

export default TeamList;
